import styles from "./AgeGuard.module.scss";

import { useSelector } from "react-redux";
import Button from "components/Button/Button";
import combineClasses from "helpers/combine-classes";
import Paragraph from "components/Paragraph/Paragraph";
import React, { Fragment, FunctionComponent, useEffect, useState } from "react";
import setInViewClasses from "blocks/hooks/setInViewClasses";
import isBrowserContext from "helpers/isBrowserContext";

const AgeGuard: FunctionComponent<any> = (props) => {
  const [viewState, setViewState] = useState<string>("INIT");
  const { inViewElementRef, inViewClasses } = setInViewClasses(styles);

  const settings = useSelector((state) => state.settings.content);

  const handleConfirmButton = () => {
    setViewState("CONFIRMED");

    if (isBrowserContext()) {
      window.localStorage.setItem("ageGuard", "true");
    }
  };

  // Deny button
  const handleDenyButton = () => {
    setViewState("DENIED");
  };

  // Checks if there is a localstorage
  useEffect(() => {
    if (isBrowserContext()) {
      const result = window.localStorage.getItem("ageGuard");

      if (result && result.length > 0) {
        setViewState("CONFIRMED");
      } else {
        // If no localstorage is found, set the initial state to "INIT"
        setViewState("INIT");
      }
    }
  }, []);

  return (
    <Fragment>
      {/* INIT */}
      {isBrowserContext() &&
      viewState === "INIT" &&
      settings?.showAgeVerification === true ? (
        <div
          className={combineClasses(styles.wrapper, inViewClasses)}
          ref={inViewElementRef}
        >
          <div className={styles.inner}>
            {/* Headline */}
            <h1 className={styles.headline}>{settings?.initialHeading}</h1>

            {/* Text */}
            <Paragraph
              className={styles.text}
              innerHTML={settings?.initialText}
            />

            {/* Buttons */}
            <div className={styles.buttons}>
              <Button
                onClick={handleConfirmButton}
                className={styles.button}
                variant={settings?.buttonVariant}
              >
                {settings?.buttonConfirmLabel}
              </Button>
              <Button
                onClick={handleDenyButton}
                className={styles.button}
                variant={settings?.buttonVariant}
              >
                {settings?.buttonDenyLabel}
              </Button>
            </div>
          </div>
        </div>
      ) : null}

      {/* CONFIRMED */}
      {!isBrowserContext() ||
      (isBrowserContext() &&
        (viewState === "CONFIRMED" ||
          settings?.showAgeVerification === false)) ? (
        <Fragment>{props.children}</Fragment>
      ) : null}

      {/* DENIED */}
      {isBrowserContext() &&
      viewState === "DENIED" &&
      settings?.showAgeVerification === true ? (
        <div className={styles.wrapper}>
          <div className={styles.container}>
            <div className={styles.inner}>
              <h1 className={styles.heading}>{settings?.deniedHeading}</h1>
              <p className={styles.text}>{settings?.deniedText}</p>
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

export default AgeGuard;
